export enum CplRosterActionsTypes {
    ALL= 'ALL',
    APPROVE = 'APPROVE'
}